// PlotlyChart.js - Custom Plotly component using minified bundle
// This reduces bundle size by ~2-3MB compared to full plotly.js

import React from 'react';
import Plotly from 'plotly.js-dist-min';
import createPlotlyComponent from 'react-plotly.js/factory';

// Create Plot component using minified Plotly
const Plot = createPlotlyComponent(Plotly);

export default Plot;
